/**
 * Layout 4 desktop grid: variant image swap.
 * Noor's _updateMedia() in theme.js only targets swiper galleries, missing
 * <product-media data-media-layout="grid">. We piggyback on Noor's
 * _renderProductInfo (which pushes a new URL with ?variant=ID via history),
 * then re-fetch and swap the grid's first-image wrapper.
 */
(function () {
  'use strict';

  function findGrid(scope) {
    return (scope || document).querySelector('product-media[data-media-layout="grid"]');
  }

  function swapFirstImage(oldGrid, newGrid) {
    if (!oldGrid || !newGrid) return false;
    // Swap only the <img> sources inside existing wrappers so wrapper
    // aspect-ratio (square) stays stable across variants. The variant
    // PNGs may be portrait — let object-fit handle the fit.
    var wrapperSel = '.product-media-grid__first-image-wrapper';
    var oldWrappers = oldGrid.querySelectorAll(wrapperSel);
    var newWrappers = newGrid.querySelectorAll(wrapperSel);
    if (!oldWrappers.length || !newWrappers.length) return false;

    oldWrappers.forEach(function (oldWrap, idx) {
      var newWrap = newWrappers[idx] || newWrappers[0];
      var oldImgs = oldWrap.querySelectorAll('img');
      var newImgs = newWrap.querySelectorAll('img');
      oldImgs.forEach(function (oldImg, j) {
        var newImg = newImgs[j] || newImgs[0];
        if (!newImg) return;
        ['src', 'srcset', 'data-src', 'data-srcset', 'alt'].forEach(function (attr) {
          var v = newImg.getAttribute(attr);
          if (v != null) oldImg.setAttribute(attr, v);
        });
      });
    });
    return true;
  }

  function getVariantIdFromUrl(url) {
    try {
      var u = new URL(url, window.location.origin);
      return u.searchParams.get('variant');
    } catch (e) { return null; }
  }

  var lastVariantId = getVariantIdFromUrl(window.location.href);

  function syncGrid() {
    var grid = findGrid();
    if (!grid) return;

    var url = window.location.href;
    var variantId = getVariantIdFromUrl(url);
    if (!variantId || variantId === lastVariantId) return;
    lastVariantId = variantId;

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = findGrid(doc);
        swapFirstImage(grid, newGrid);
      })
      .catch(function () {});
  }

  // Patch history.pushState/replaceState to detect Noor's URL update.
  ['pushState', 'replaceState'].forEach(function (method) {
    var orig = history[method];
    history[method] = function () {
      var ret = orig.apply(this, arguments);
      setTimeout(syncGrid, 50);
      return ret;
    };
  });

  // Fallback: also listen on variants-set change (delayed, after Noor finishes).
  function init() {
    document.querySelectorAll('variants-set').forEach(function (vs) {
      vs.addEventListener('change', function () {
        clearTimeout(vs.__gridSwapTimer);
        vs.__gridSwapTimer = setTimeout(syncGrid, 600);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
